import { BaseType } from "@/types/base-type";

export interface ISalaryScale extends BaseType {
  id: number;
  code: string;
  name: string;
  baseSalary: number;
  roundingMode: ERoundingMode;
  roundingStep: number;
  description: string;
  effectiveDate: Date;
  expirationDate?: Date;
}

export interface ISalaryGrade extends BaseType {
  id: number;
  code: string;
  name: string;
  description: string;
  order: number;
}

export interface ISalaryStep extends BaseType {
  id: number;
  level: number;
  increasePercent: number;
}

export enum ERoundingMode {
  None = 0,
  Up = 1,
  Down = 2,
  Nearest = 3,
}
